// extracted by mini-css-extract-plugin
export var entityChip = "_sa-0";
export var entityChipMissing = "_sa-1";